import { isProduction } from "./is-production";

function determineEnvironment(): "localhost" | "utv" | "qa" | "production" {
  if (process.env.NODE_ENV === "development") {
    return "localhost";
  }
  const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET;
  if (dataset === "utv" || dataset === "qa" || dataset === "production") {
    return dataset;
  }
  return "utv";
}

const environment: "localhost" | "utv" | "qa" | "production" =
  determineEnvironment();

const origin =
  environment === "production"
    ? ("https://cappelendamm.no" as const)
    : process.env.VERCEL_URL
      ? (`https://${process.env.VERCEL_URL}` as const)
      : ("https://utv-cappelendamm.vercel.app" as const);

export const app = {
  name: "netthandel-web" as const,
  origin,
  environment,
  isProduction,
};
